var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 31,
    r: 31,
    transform: "matrix(-1 0 0 1 62 0)",
    fill: "#4EC8D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3776 13.7346C37.5477 12.7551 36.2023 12.7551 35.3724 13.7346L22.6224 28.783C21.7925 29.7625 21.7925 31.3505 22.6224 32.3299L35.3724 47.3783C36.2023 48.3578 37.5477 48.3578 38.3776 47.3783C39.2075 46.3989 39.2075 44.8108 38.3776 43.8314L27.1302 30.5565L38.3776 17.2815C39.2075 16.3021 39.2075 14.7141 38.3776 13.7346Z",
    fill: "#FEDC74",
    stroke: "#FEDC74",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftButton);
export default __webpack_public_path__ + "static/media/leftButton.476f301e2cc241a34bc33d346b1e32b1.svg";
export { ForwardRef as ReactComponent };